import Base from './Base';

class Auth extends Base {
    check(query = null, opts = null) {
        return this.getJSONWithSession(this.urlGenerator('auth.check'), query, opts).catch((e) => {
            if (e.status === 401) {
                return null;
            }
            throw e;
        });
    }

    sendToken(data, opts = null) {
        return this.postJSONWithSession(this.urlGenerator('auth.token'), data, opts);
    }

    login(data, opts = null) {
        return this.postJSONWithSession(this.urlGenerator('auth.login'), data, opts);
    }

    logout(opts = null) {
        return this.getJSONWithSession(this.urlGenerator('auth.logout'), null, opts);
    }
}

export default Auth;
